
import { AddItemComponent } from './components/add-item/add-item.component';
import { AddressFormComponent } from './components/address-form/address-form.component';
import { AutoCompleteCustomerComponent } from './components/autocomplete-customer/autocomplete-customer.component';
import { BarcodeComponent } from './components/barcode/barcode.component';
import { CityPipe } from './pipes/city';
import { CommonModule, Location } from '@angular/common';
import { ConfigService } from './services/config.service';
import { ConfirmationDialogComponent } from './components/confirmation-dialog/confirmation-dialog.component';
import { ContactFormComponent } from './components/contact-form/contact-form.component';
import { CustomerService } from '../../modules/customer/services/customer.service';
import { DefaultActionsComponent } from './components/default-actions/default-actions.component';
import { DeliveryCycleService } from './services/delivery-cycle.service';
import { DisplayCustomerTypePipe } from './pipes/display-customer-type';
import { DisplayRequirementPeriodPipe } from './pipes/display-requirement-period';
import { DtaTypePipe } from './pipes/dta-type.pipe';
import { FormErrorComponent } from './components/form-error/form-error.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GreaterThanDate } from './directives/greater-than-date';
import { HttpService } from './services/http.service';
import { ItemFormComponent } from './components/item-form/item-form.component';
import { ItemListComponent } from './components/item-list/item-list.component';
import { ItemsComponent } from './components/items/items.component';
import { ItemService } from './services/item.service';
import { LoadingComponent } from './components/loading/loading.component';
import { ModalService } from './services/modal.service';
import { MonthYearSelectorComponent } from './components/month-year-selector/month-year-selector.component';
import { NbDecimalPipe } from './pipes/nb-decimal';
import { NbInvoiceNumberPipe } from './pipes/nb-invoice-number';
import { NbItemPipe } from './pipes/nb-item-pipe';
import { NgbDateMomentParserFormatter, DateFormats } from 'src/app/shared/custom-ngb-parser';
import { NgbProgressbarModule, NgbDateParserFormatter, NgbPaginationModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgModule } from '@angular/core';
import { NgxSpinnerModule } from 'ngx-spinner';
import { PaginatorComponent } from './components/paginator/paginator.component';
import { PersonNamePipe } from './pipes/person-name';
import { ProgressBarComponent } from './components/progress-bar/progress-bar.component';
import { ReadableBoolPipe } from './pipes/readable-bool';
import { readableShippingStatusPipe } from './pipes/readable-shipping-status';
import { RouterModule } from '@angular/router';
import { SelectDateModalComponent } from './components/select-date-modal/select-date-modal.component';
import { SortableDirective } from './directives/sortable.directive';
import { StateService } from './services/state.service';
import { StreetPipe } from './pipes/street';
import { UserService } from './services/user.service';
import { WarnIconComponent } from './components/warn-icon/warn-icon.component';

@NgModule({
  declarations: [
    AddItemComponent,
    AddressFormComponent,
    AutoCompleteCustomerComponent,
    BarcodeComponent,
    CityPipe,
    ConfirmationDialogComponent,
    ContactFormComponent,
    DefaultActionsComponent,
    DisplayCustomerTypePipe,
    DisplayRequirementPeriodPipe,
    DtaTypePipe,
    FormErrorComponent,
    GreaterThanDate,
    ItemFormComponent,
    ItemListComponent,
    ItemsComponent,
    LoadingComponent,
    MonthYearSelectorComponent,
    NbDecimalPipe,
    NbInvoiceNumberPipe,
    NbItemPipe,
    PaginatorComponent,
    PersonNamePipe,
    ProgressBarComponent,
    ReadableBoolPipe,
    readableShippingStatusPipe,
    SelectDateModalComponent,
    SortableDirective,
    StreetPipe,
    WarnIconComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    NgbModule,
    NgbPaginationModule,
    NgbProgressbarModule,
    NgxSpinnerModule,
    ReactiveFormsModule,
    RouterModule,
  ],
  exports: [
    AddItemComponent,
    AddressFormComponent,
    AutoCompleteCustomerComponent,
    BarcodeComponent,
    CityPipe,
    ConfirmationDialogComponent,
    ContactFormComponent,
    DefaultActionsComponent,
    DisplayCustomerTypePipe,
    DisplayRequirementPeriodPipe,
    DtaTypePipe,
    FormErrorComponent,
    GreaterThanDate,
    ItemListComponent,
    ItemsComponent,
    LoadingComponent,
    NbDecimalPipe,
    NbInvoiceNumberPipe,
    NbItemPipe,
    PaginatorComponent,
    PersonNamePipe,
    ReadableBoolPipe,
    readableShippingStatusPipe,
    SelectDateModalComponent,
    SortableDirective,
    StreetPipe,
    WarnIconComponent,
  ],
  bootstrap: [],
  providers: [
    CityPipe,
    ConfigService,
    CustomerService,
    DeliveryCycleService,
    HttpService,
    ItemService,
    Location,
    ModalService,
    NbDecimalPipe,
    NbItemPipe,
    PersonNamePipe,
    StateService,
    StreetPipe,
    UserService,
    {
      provide: NgbDateParserFormatter, useFactory: () => {
        return new NgbDateMomentParserFormatter(DateFormats.GermanDate);
      }
    }, {
      provide: NgbDateMomentParserFormatter, useFactory: () => {
        return new NgbDateMomentParserFormatter(DateFormats.GermanDate);
      }
    },
  ],
  entryComponents: [
    AddItemComponent,
    AddressFormComponent,
    ConfirmationDialogComponent,
    MonthYearSelectorComponent,
    ProgressBarComponent,
    SelectDateModalComponent,
  ]
})

export class SharedModule {
}
